(function () {
    'use strict';

    run.admin.parts.rackootFavicons = function() {
        // Display
        const grid = document.querySelector('.tools_grid');
        const faviconDisplayStatus = grid.dataset.faviconsUse;
        if (faviconDisplayStatus == '1') { tilesFaviconsSwitch(true); }

        // Switch
        const favicons_toggler = document.getElementById('rackoot__favicons');
        if (favicons_toggler !== null && favicons_toggler !== 'undefined') {
            favicons_toggler.addEventListener('change', function(e) {
                const checked = this.checked;
                (checked) ? tilesFaviconsSwitch(true) : tilesFaviconsSwitch(false);
                (checked) ? saveFaviconsSettings(true) : saveFaviconsSettings(false);
                grid.dataset.faviconsUse = checked;
                // setCookie('rackoot__favicons', checked, 180);
            });
        }

        function tilesFaviconsSwitch(status)
        {
            const grid = document.getElementById('tool_group__active');
            const tiles = grid.querySelectorAll('.tool');
            grid.dataset.displayFavicons = "true";
            
            [].forEach.call(tiles, function(tile) {
                (status == true) ? TileFaviconsEnable(tile) : TileFaviconsDisable(tile);
            });
        }

        function TileFaviconsEnable(tile)
        {
            appendFaviconToTile(tile);
        }

        function TileFaviconsDisable()
        {
            const grid = document.getElementById('tool_group__active');
            grid.dataset.displayFavicons = "false";
        }

        function saveFaviconsSettings(status)
        {
            const csrf_name = document.getElementsByName('csrf_name')[0].value;
            const csrf_value = document.getElementsByName('csrf_value')[0].value;
            const saveRackootSettingsUrl = GlobalRoutes.rackoots.settings;
            status = (status == true) ? 1 : 0;

            var data = new FormData();
            data.append('csrf_name', csrf_name);
            data.append('csrf_value', csrf_value);
            data.append('rackoot_uuid', rackoot_data.dataset.uuid);
            data.append('favicons_use', status);

            axios.post(saveRackootSettingsUrl, data)
            .then(function (response) {
                // new Toast(response.data.message, Toast.TYPE_DONE, Toast.TIME_NORMAL);
            })
            .catch(function (error) {
                new Toast(error.response.data.error, Toast.TYPE_ERROR, Toast.TIME_NORMAL);
            });
        }
    }
})();
